import React from 'react';

import { ButtonSizes } from '@Components/Buttons/Button';
import ButtonFavorite from '@Components/Buttons/ButtonFavorite/ButtonFavorite';
import { useFavoriteAdvertMutation } from '@Graphql/graphqlTypes.generated';

interface AdFavoriteButtonProps {
  favoriteAdvertId: string;
  isAdFavorited: boolean;
  showSuccessMessage?: boolean;
  onStatusUpdateSuccess?: () => void;
  withLabel?: boolean;
  size?: ButtonSizes;
  inPicture?: boolean;
}

const AdFavoriteButton: React.FunctionComponent<AdFavoriteButtonProps> = ({
  favoriteAdvertId,
  isAdFavorited,
  onStatusUpdateSuccess,
  withLabel,
  size = ButtonSizes.unset,
  inPicture,
}) => {
  const [updateFavoriteAdStatus] = useFavoriteAdvertMutation({
    onCompleted: () => {
      if (onStatusUpdateSuccess) {
        onStatusUpdateSuccess();
      }
    },
  });

  const toggleFavoriteAd = () => {
    updateFavoriteAdStatus({
      variables: {
        input: { id: favoriteAdvertId },
      },
    });
  };

  return (
    <ButtonFavorite
      onChangeStatus={toggleFavoriteAd}
      isFavorited={isAdFavorited}
      size={size}
      withLabel={withLabel}
      inPicture={inPicture}
    />
  );
};

export default AdFavoriteButton;
